// extracted by mini-css-extract-plugin
export var articlesRelatedContent = "articleDetail-module--articles-related-content--1nIF5";